/**
 * Centralized copy for the Book Draft Switcher (Members > Book Draft Switcher).
 * Kept out of the component per the repo rule that feature text is not
 * hardcoded inline (mirrors MemberBooksTab.strings.ts).
 */
export const bookDraftsStrings = {
  loadError: "Failed to load draft versions.",
  switchError: "Failed to switch the current draft.",
  switched: "Current draft updated. Ask the customer to reopen the book fresh.",
  alreadyCurrent: "{id} is already the current draft. Nothing changed.",
  newCopyMadeCurrent:
    "This version is locked by a print order, so a new editable copy ({copyId}) was made current. Ask the customer to reopen the book fresh.",
  existingCopyMadeCurrent:
    "This version is locked by a print order, so the existing editable copy ({copyId}) was made current. Ask the customer to reopen the book fresh.",
  existingCopyAlreadyCurrent:
    "This version is locked by a print order. Its editable copy ({copyId}) is already the current draft. Nothing changed.",
  undo: "Undo — restore {id} as current",
  copyOf: "Copy of {id}",
} as const;

/**
 * Replaces `{token}` placeholders with provided values; unknown tokens are left
 * intact so missing interpolation is visible.
 */
export const formatMessage = (
  template: string,
  vars: Record<string, string | number> = {}
): string =>
  template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : match
  );
